import { FunctionComponent, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Analytics } from './Analytics';

/**
 * Logs a page_view analytics event whenever the route changes. Firebase Analytics only
 * tracks the initial page load automatically - client-side route changes need this.
 * Must be rendered inside BrowserRouter. 
 */
export const PageViewTracker: FunctionComponent = () => {
	const { pathname } = useLocation();

	useEffect(function trackPageView() {
		Analytics.track('page_view', { page_path: pathname });
	}, [pathname]);

	return null;
};
